/* eslint-disable class-methods-use-this */
import SpinProvider from './SpinProvider';
import type { RandomSpin } from './types';
import FunSpinProvider from 'rf-ui/GameRenderer/spinProvider/FunSpinProvider';

export default class CrazySoleaSpinProvider extends FunSpinProvider {

}
